<template>
    <div class="leave-index">
        <!-- <myBreadCrumb :urls="JSON.stringify(breadcrumbs)" @createForm="dialog.state=true" :icon="icon"></myBreadCrumb> -->
        <create-dialog v-model="dialog" @CloseDialog="closeHandler" @fetchData="fetchData"></create-dialog>
        
        <v-card class="rounded-xl elevation-3">
            <v-card-title class="text-h6 font-weight-bold pt-4 pb-2 px-6">
                Phiếu hỗ trợ xác nhận giờ công
                <v-spacer></v-spacer> 
                
                <!-- Refresh Button -->
                <div class="d-flex align-center wrapper mx-1 my-1">
                    <v-btn @click="fetchData" outlined color="green lighten-3" class="rounded-lg" block style="width: 40px !important; height: 40px; padding: 0px;">
                        <v-icon color="green darken-4">mdi-refresh</v-icon>
                    </v-btn>
                </div>
                
                <!-- Export Excel Button -->
                <v-btn @click="exportExcel" outlined color="teal lighten-3" class="rounded-lg ml-2" style="width: 40px !important; height: 40px; padding: 0px;">
                    <v-icon color="teal darken-4">mdi-microsoft-excel</v-icon>
                </v-btn>

                <v-divider vertical class="mx-4"></v-divider>

                <!-- Action Buttons -->
                <v-btn v-if="selected.length > 0" @click="deleteHandler" dark color="red darken-4" class="rounded-pill elevation-3 ml-4 font-weight-bold px-6"> 
                    <v-icon left>mdi-undo</v-icon> THU HỒI
                </v-btn>

                <v-btn @click="openCreateHandler" dark color="teal darken-4" class="rounded-pill elevation-3 ml-4 font-weight-bold px-6"> 
                    <v-icon left>mdi-plus</v-icon> TẠO PHIẾU 
                </v-btn>
            </v-card-title>

            <!-- Filters Section -->
            <v-sheet class="grey lighten-4 py-6">
                <div class="d-flex flex-wrap mx-n2 px-4">
                    <div class="d-flex align-center wrapper mx-2 my-2">
                        <month-picker width="7rem" v-model="month" label="Chọn tháng" outlined dense></month-picker>
                    </div>
                    <v-text-field label="Tìm kiếm" placeholder="Nhập Mã NS, tên NS,... để tìm kiếm" dense v-model="globalSearch" outlined hide-details persistent-placeholder
                        class="mx-2 my-2 flex-grow-1 flex-shrink-0" style="max-width: 300px; background-color: white;"></v-text-field>
                </div>
            </v-sheet>

            <!-- Statistics Section -->
            <v-sheet class="px-6 py-3 d-flex align-center grey lighten-5" style="border-top: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
                <div class="subtitle-2 font-weight-bold mr-4 text-uppercase grey--text text--darken-2">Thống kê:</div>
                <v-chip color="blue lighten-4" text-color="blue darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-file-document-outline</v-icon>
                    Tổng phiếu: <b class="ml-1">{{ totalCount }}</b>
                </v-chip>
                <v-chip color="orange lighten-4" text-color="orange darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-clock-outline</v-icon>
                    Chờ duyệt: <b class="ml-1">{{ pendingCount }}</b>
                </v-chip>
                <v-chip color="green lighten-4" text-color="green darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-check-circle-outline</v-icon>
                    Hoàn tất: <b class="ml-1">{{ confirmedCount }}</b>
                </v-chip>
                <v-chip color="red lighten-4" text-color="red darken-4" class="font-weight-medium" small>
                    <v-icon left small>mdi-close-circle-outline</v-icon>
                    Từ chối: <b class="ml-1">{{ rejectedCount }}</b>
                </v-chip>
            </v-sheet>

            <!-- Data Table -->
            <v-data-table height="600px" :search="globalSearch" :mobile-breakpoint="0" :headers="headers" :items="items"
                single-select show-select v-model="selected" :loading="isLoading" loading-text="Đang tải dữ liệu...">

                <!-- Table Actions -->
                <template v-slot:[`item.actions`]="{ item }">
                    <v-btn x-small depressed rounded v-if="item.confirmLevel === 0 && !item.isReject" class="mx-1 my-1 red--text text--darken-3 font-weight-bold" color="red lighten-4" @click="deleteItem(item)">
                        <v-icon left small>mdi-close-circle</v-icon> Thu hồi
                    </v-btn>
                </template>

                <!-- Table Fields Styling -->
                <template v-slot:[`item.employeeInfo`]="{ item }">
                    <div class="subtitle-2 font-weight-bold" style="line-height: 1.2;">{{ item.employeeName }}</div>
                    <div class="caption grey--text">{{ item.employeeCode }}</div>
                    <div class="caption grey--text text--darken-1" v-if="item.departmentName || item.divisionName">
                        {{ item.departmentName }} <span v-if="item.departmentName && item.divisionName">-</span> {{ item.divisionName }}
                    </div>
                </template>

                <template v-slot:[`item.workDate`]="{ item }">
                    <div style="line-height: 1.2;">
                        <span class="font-weight-medium text-body-2">{{ formatDate(item.workDate) }}</span>
                        <div class="caption grey--text" v-if="item.createdAt">
                            Tạo: {{ formatDate(item.createdAt) }} {{ formatTime(item.createdAt) }}
                        </div>
                    </div>
                </template>

                <template v-slot:[`item.reason`]="{ item }">
                    <div style="line-height: 1.3;">
                        <span class="font-weight-medium text-body-2 teal--text text--darken-4">{{ item.reasonTypeName }}</span>
                        <div class="caption text-truncate grey--text text--darken-2" style="max-width: 230px;" v-if="item.note" :title="item.note">
                            {{ item.note }}
                        </div>
                    </div>
                </template>

                <template v-slot:[`item.approverInfo`]="{ item }">
                    <div class="caption" style="line-height: 1.4;">
                        <!-- Quản lý trực tiếp -->
                        <div v-if="item.managerName" class="d-flex align-center">
                            <v-icon x-small :color="item.confirmLevel >= 1 ? 'success' : (item.isReject && item.rejectedByCode === item.managerCode ? 'error' : 'grey')">
                                {{ item.confirmLevel >= 1 ? 'mdi-check-circle' : (item.isReject && item.rejectedByCode === item.managerCode ? 'mdi-close-circle' : 'mdi-minus-circle') }}
                            </v-icon>
                            <span class="ml-1" :class="item.confirmLevel >= 1 ? 'green--text text--darken-3 font-weight-medium' : ''">QL: {{ item.managerName }}</span>
                        </div>
                        <!-- Nhân sự phụ trách -->
                        <div v-if="item.hrAdminName" class="d-flex align-center">
                            <v-icon x-small :color="item.confirmLevel >= 2 ? 'success' : (item.isReject && item.rejectedByCode === item.hrAdminCode ? 'error' : 'grey')">
                                {{ item.confirmLevel >= 2 ? 'mdi-check-circle' : (item.isReject && item.rejectedByCode === item.hrAdminCode ? 'mdi-close-circle' : 'mdi-minus-circle') }}
                            </v-icon>
                            <span class="ml-1" :class="item.confirmLevel >= 2 ? 'green--text text--darken-3 font-weight-medium' : ''">HR: {{ item.hrAdminName }}</span>
                        </div>
                        <!-- Giám đốc nhân sự -->
                        <div v-if="item.hrManagerName" class="d-flex align-center">
                            <v-icon x-small :color="item.confirmLevel >= 3 ? 'success' : (item.isReject && item.rejectedByCode === item.hrManagerCode ? 'error' : 'grey')">
                                {{ item.confirmLevel >= 3 ? 'mdi-check-circle' : (item.isReject && item.rejectedByCode === item.hrManagerCode ? 'mdi-close-circle' : 'mdi-minus-circle') }}
                            </v-icon>
                            <span class="ml-1" :class="item.confirmLevel >= 3 ? 'green--text text--darken-3 font-weight-medium' : ''">GĐ: {{ item.hrManagerName }}</span>
                        </div>
                    </div>
                </template>

                <template v-slot:[`item.imageUrl`]="{ item }">
                    <v-hover v-if="item.imageUrl" v-slot="{ hover }">
                        <v-card :elevation="hover ? 4 : 1" class="transition-swing cursor-pointer rounded-lg overflow-hidden" max-width="50" @click="viewUrl = item.imageUrl">
                            <v-img :src="item.imageUrl" max-width="50" height="40" cover>
                                <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular indeterminate color="grey lighten-5" size="16"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                        </v-card>
                    </v-hover>
                    <span v-else class="grey--text caption">Không có ảnh</span>
                </template>

                <template v-slot:[`item.confirmLevel`]="{ item }">
                    <v-chip :color="getStatusColor(item)" small dark class="font-weight-medium" style="width: 130px; justify-content: center;">
                        {{ getStatusText(item) }}
                    </v-chip>
                </template>
            </v-data-table>
        </v-card>

        <!-- ************** DELETE CONFIRMATION *************** -->
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card class="rounded-xl">
                <v-card-title class="headline text-subtitle-1 font-weight-bold">Bạn có chắc muốn xoá dữ liệu này?</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="dialogDelete = false">Thoát</v-btn>
                    <v-btn color="red darken-1" text @click="cfmDeleteItem">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- ************** IMAGE VIEWER *************** -->
        <v-dialog :value="!!viewUrl" persistent fullscreen>
            <v-card dark>
                <v-card-title>
                    Xem ảnh minh chứng
                    <v-spacer></v-spacer>
                    <v-icon @click="viewUrl = null">mdi-close</v-icon>
                </v-card-title>
                <v-img :src="viewUrl" class="my-auto" style="max-height: calc(100vh - 60px);" contain></v-img>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import * as moment from "moment/moment";
import CreateButton from '@/components/Crud/CreateButton';
import http from '@/components/services/http-common';
import Create from './Create.vue';
import DataFilter from '@/components/DataFilter.vue';
import headers from "./headerPersonal";
import { getPersonal, remove } from "./api"

export default {
    name: 'Leave',
    components: {
        CreateButton,
        "create-dialog": Create,
        "data-filter": DataFilter
    },
    watch: {
        tableParams: {
            handler(val) {
                // Fetch data when table page or sort params change
                this.fetchData();
            },
            deep: true,
        },
        filters: {
            handler(val) {
                this.tableParams.page = 1;
                // Fetch data when filters are updated
                this.fetchData();
            },
            deep: true,
        },
        month: {
            handler(val) {
                // Adjust filter date range based on month value changes
                this.filters.from = moment(val, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
                this.filters.to = moment(val, "YYYY-MM").endOf("month").format("YYYY-MM-DD");
            }
        }
    },

    computed: {
        webAllowed() {
            let user = localStorage.getItem("user");
            let webAllowed = localStorage.getItem("WebAllowed");
            user = JSON.parse(user);
            return webAllowed.includes(user.employeeCode);
        },
        params: function () {
            return { ...this.tableParams, ...this.filters }
        },
        // Statistics counters for request status chips
        totalCount() {
            return this.items.length;
        },
        pendingCount() {
            return this.items.filter(item => !item.isReject && item.confirmLevel < 3).length;
        },
        confirmedCount() {
            return this.items.filter(item => !item.isReject && item.confirmLevel === 3).length;
        },
        rejectedCount() {
            return this.items.filter(item => item.isReject).length;
        }
    },
    data() {
        return {
            // Root API route for timesheet confirmation requests
            ROOT_URL: "TimesheetConfirmRequests/",

            // Header configuration
            icon: {
                icon: "mdi-plus-thick",
                to: ""
            },

            // Filter states
            month: moment().format("YYYY-MM"),
            changeArea: false,
            globalSearch: "",
            filters: {
                code: null,
                employeeName: null,
                from: moment().startOf("month").format("YYYY-MM-DD"),
                to: moment().endOf("month").format("YYYY-MM-DD"),
            },
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
            },
            selected: [],
            rowCount: 0,

            // Data table headers
            headers: headers,

            items: [],
            options: {},
            isLoading: true,

            // Dialog controllers
            dialog: {
                state: false,
                item: undefined,
            },
            dialogDelete: false,
            targetItem: {},
            viewUrl: "",
        }
    },

    methods: {
        // Get confirmation level CSS color code
        colorClass(value) {
            switch (value) {
                case 0: return "primary"
                case 1: return "green darken-3"
                case 2: return "red darken-3"
                default: return ""
            }
        },
        // Format ISO Date string to DD/MM/YYYY
        formatDate(value) {
            return moment(value).format("DD/MM/YYYY");
        },
        // Format ISO Date string to HH:mm:ss
        formatTime(value) {
            return moment(value).format("HH:mm:ss");
        },
        // Convert status levels to readable Vietnamese string
        getStatusText(item) {
            if (item.isReject) return "Từ chối";
            switch (item.confirmLevel) {
                case 0: return "Tạo mới";
                case 1: return "Quản lý đã duyệt";
                case 2: return "HR đã duyệt";
                case 3: return "Hoàn tất";
                default: return "Chờ duyệt";
            }
        },
        // Map confirmation levels and rejection to Vuetify color palettes
        getStatusColor(item) {
            if (item.isReject) return "error";
            switch (item.confirmLevel) {
                case 0: return "primary";
                case 1: return "info";
                case 2: return "warning";
                case 3: return "success";
                default: return "grey";
            }
        },

        // Fetch personal timesheet requests
        fetchData() {
            this.isLoading = true;
            getPersonal(this.month)
                .then(res => {
                    this.items = res.data.data;
                    this.isLoading = false;
                })
                .catch(err => {
                    console.error("Error fetching data:", err);
                    this.isLoading = false;
                });
        },
        // Export data to Excel
        exportExcel() {
            return http.get(this.ROOT_URL + "hr/export", {
                params: {
                    month: moment(this.month).format('YYYY-MM-DD')
                },
                responseType: 'blob',
            }).then(res => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `DANH SACH_PHIEU_HT_${moment(this.month, 'yyyy-MM-dd').format("MM-YYYY")}.xlsx`);
                document.body.appendChild(link);
                link.click();
            });
        },

        changeItemStatus(id, status) {
            return http.get(`${this.ROOT_URL}hr/change-status`, {
                params: {
                    id: id,
                    status: status
                }
            })
            .catch(() => { this.fetchData() })
        },

        // Close request creation dialog
        closeHandler() {
            this.dialog = { state: false, item: undefined }
        },
        // Trigger dialog for request editing
        editItem(item) {
            this.dialog = { state: true, item: item }
        },
        // Trigger delete prompt dialog for specific item
        deleteItem(item) {
            this.dialogDelete = true;
            this.targetItem = item;
        },
        // Call API to remove targeted request
        cfmDeleteItem() {
            remove([this.targetItem]).then(res => {
                this.fetchData();
                this.dialogDelete = false;
            }).catch(err => {
                console.error("Delete error:", err);
                if (err.response && err.response.status === 403) {
                    this.unauthorizeAlert();
                }
                this.dialogDelete = false;
            })
        },
        // Remove currently selected requests from checkboxes
        deleteHandler() {
            remove(this.selected).then(r => {
                this.selected = [];
                this.fetchData();
            }).catch(err => {
                console.error("Bulk delete error:", err);
            });
        },

        // Open creation form dialog
        openCreateHandler() {
            this.dialog = { ...this.dialog, state: true }
        }
    },

    created() {
        this.fetchData();
    }
}
</script>